<template>
	<section class="i-emitent">
		<div class="i-emitent__container">
			<div
				v-if="investorsDataIsLoading || investorsData"
				class="i-emitent__component"
			>
				<loader v-if="investorsDataIsLoading" />
				<presentations
					v-if="investorsData?.data.props.presentation"
					:presentations-data="presentations"
					:api-data="investorsData.data.props.presentation"
				/>
				<reporting-and-results
					v-else
					:reporting-and-results-data="presentations"
				/>
			</div>
			<div
				class="i-emitent__component"
				:class="{ large: reportingAndResults.large }"
			>
				<reporting-and-results
					:reporting-and-results-data="reportingAndResults"
				/>
			</div>
			<div
				v-if="investorsDataIsLoading || investorsData"
				class="i-emitent__component"
			>
				<loader v-if="investorsDataIsLoading" />
				<bond-issues
					v-if="investorsData"
					:bond-issues-data="bondIssues"
					:api-data="investorsData.data.props"
				/>
			</div>
			<div
				class="i-emitent__component"
				:class="{ large: reportingAndResults.large }"
			>
				<reporting-and-results :reporting-and-results-data="projects" />
			</div>
			<div class="i-emitent__col">
				<div
					v-if="investorsDataIsLoading || investorsData"
					class="i-emitent__component small"
				>
					<loader v-if="investorsDataIsLoading" />
					<credit-ratings
						v-if="
							investorsData &&
							investorsData.data.props.credit_esg.credit_ratings
						"
						:credit-ratings-data="
							investorsData.data.props.credit_esg.credit_ratings
						"
						small
					/>
				</div>
				<div
					v-if="investorsDataIsLoading || investorsData"
					class="i-emitent__component"
				>
					<loader v-if="investorsDataIsLoading" />
					<esg-ratings
						v-if="investorsData && investorsData.data.props.credit_esg.esg"
						:esg-ratings-data="investorsData.data.props.credit_esg.esg"
					/>
				</div>
			</div>
			<div class="i-emitent__col">
				<div
					class="i-emitent__component"
					:class="{ small: informationDisclosure.small }"
				>
					<reporting-and-results
						:reporting-and-results-data="informationDisclosure"
					/>
				</div>
				<div
					class="i-emitent__component"
					:class="{ small: financingBonds.small }"
				>
					<reporting-and-results :reporting-and-results-data="financingBonds" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import Loader from '../vue-components/Loader'
import ReportingAndResults from './components/ReportingAndResults'
import InvestorCalendar from './components/InvestorCalendar'
import Presentations from './components/Presentations'
import BondIssues from './components/BondIssues'
import CreditRatings from './components/CreditRatings'
import EsgRatings from './components/EsgRatings'
import { investorsDataActionTypes } from '../store/modules/investors/investors'
import { mapState } from 'vuex'

export default {
	name: 'Domrf',
	components: {
		Loader,
		ReportingAndResults,
		InvestorCalendar,
		Presentations,
		BondIssues,
		CreditRatings,
		EsgRatings,
	},
	computed: {
		...mapState({
			investorsDataIsLoading: state => state.investorsData.isLoading,
			investorsData: state => state.investorsData.data,
			investorsDataError: state => state.investorsData.error,
		}),
	},
	methods: {
		getDateNow() {
			const options = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			}
			const timeElapsed = Date.now()
			return new Date(timeElapsed).toLocaleString('ru', options)
		},
	},
	data() {
		return {
			apiUrl: '/api/v2/content/investors/infrastrukturnye-obligacii/',
			reportingAndResults: {
				picture: {
					src: '/static/v2/src/img/investors/sopf/reporting-and-results',
					name: 'Аналитика',
					width: '288',
					height: '252',
				},
				header: 'Аналитика',
				desc: 'Основные результаты работы механизма по финансированию региональной инфраструктуры',
				link: '/investors/infrastrukturnye-obligacii/results/',
			},
			presentations: {
				labelBgColor: '#A3D562',
				picture: {
					src: '/static/v2/src/img/investors/sopf/presentation',
					name: 'Презентации',
					width: '288',
					height: '252',
				},
				header: 'Презентации',
				desc: 'Страница находится в разработке',
			},
			creditRatings: {
				small: true,
				header: 'Кредитные рейтинги',
				creditRatings: {
					items: [
						{
							icon: {
								src: '/static/v2/src/img/investors/icons/akra.svg',
								name: 'Akra',
								width: '164',
								height: '24',
							},
							value: 'ААА(RU)',
							press: {
								text: 'Подробнее',
								link: 'https://www.acra-ratings.ru/ratings/issuers/333/',
							},
						},
						{
							icon: {
								src: '/static/v2/src/img/investors/icons/expert.svg',
								name: 'Expert',
								width: '110',
								height: '24',
							},
							value: 'ruAAA',
							press: {
								text: 'Подробнее',
								link: 'https://raexpert.ru/database/companies/1000042272/',
							},
						},
					],
				},
			},
			bondIssues: {
				header: 'Выпуски облигаций',
				image: '/static/v2/src/img/investors/icons/graph.png',
				issues: {
					name: 'Количество выпусков',
				},
				sum: {
					name: 'Объем выпусков',
				},
				date: 'В обращении',
				link: '/investors/infrastrukturnye-obligacii/bonds/',
			},
			projects: {
				labelBgColor: '#D6CDC7',
				header: 'Реализуемые проекты',
				link: 'https://xn--n1aceo.xn--d1aqf.xn--p1ai/development/',
				picture: {
					src: '/static/v2/src/img/investors/sopf/projects',
					name: 'Реализуемые проекты',
					width: '256',
					height: '208',
				},
			},
			informationDisclosure: {
				small: true,
				labelBgColor: '#E3EEFF',
				header: 'Раскрытие информации',
				link: 'https://www.e-disclosure.ru/portal/company.aspx?id=38376',
				picture: {
					src: '/static/v2/src/img/investors/domrf/information-disclosure',
					name: 'Раскрытие информации',
					width: '256',
					height: '208',
				},
			},
			esgRatings: {
				small: true,
				title: 'ESG',
				items: [
					{
						icon: {
							src: '/static/v2/src/img/investors/icons/expert-black.svg',
							name: 'Expert',
							width: '110',
							height: '24',
						},
						value: 'Соответствие принципам социальных облигаций',
						press: 'https://raexpert.ru/database/companies/1000042272/',
					},
				],
			},
			financingBonds: {
				small: true,
				labelBgColor: '#D6CDC7',
				header:
					'Облигации на финансирование инфраструктуры с поручительством ДОМ.РФ',
				desc: 'Подробнее на сайте',
				link: 'https://xn--n1aceo.xn--d1aqf.xn--p1ai/',
			},
		}
	},
	beforeMount() {
		this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {
			apiUrl: this.apiUrl,
		})
	},
}
</script>
